import { useState, type FormEvent } from 'react';
import { postForm } from '@/components/base/postForm';

const SUBMIT_ADDR = 'https://readdy.ai/api/form/dagmi8jep053ijub2dr0';
const SUCCESS_MSG = '订阅成功！我们会第一时间把最新爆料摘要推送到您的邮箱。';

export default function NewsletterForm({ id = 'newsletter-form' }: { id?: string }) {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const form = e.currentTarget;
    setStatus('idle');
    const result = await postForm(SUBMIT_ADDR, form, SUCCESS_MSG);
    if (result.ok) {
      setStatus('success');
      setMessage(result.message);
      form.reset();
    } else {
      setStatus('error');
      setMessage(result.message);
    }
  }

  return (
    <div>
      <form
        id={id}
        data-readdy-form={id}
        onSubmit={handleSubmit}
        className="mx-auto flex w-full max-w-xl flex-col gap-2 sm:flex-row sm:items-center"
        noValidate
      >
        <label htmlFor={`${id}-email`} className="sr-only">
          邮箱地址
        </label>
        <input
          id={`${id}-email`}
          type="email"
          name="email"
          required
          autoComplete="email"
          placeholder="输入你的邮箱，接收每日新料"
          className="h-12 w-full flex-1 rounded-full border border-background-200 bg-background-50 px-5 text-sm text-foreground-900 outline-none transition-colors focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
        />
        {/* 反垃圾蜜罐 */}
        <input type="text" name="website_alt" autoComplete="off" tabIndex={-1} aria-hidden="true" readOnly />
        <button
          type="submit"
          className="inline-flex h-12 shrink-0 items-center justify-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300"
        >
          <i className="ri-mail-send-line" aria-hidden="true" />
          立即订阅
        </button>
      </form>
      {status === 'success' && (
        <p role="status" className="mt-3 flex items-center justify-center gap-2 text-sm text-accent-700">
          <i className="ri-checkbox-circle-line" aria-hidden="true" />
          {message}
        </p>
      )}
      {status === 'error' && (
        <p role="alert" className="mt-3 flex items-center justify-center gap-2 text-sm text-primary-700">
          <i className="ri-error-warning-line" aria-hidden="true" />
          {message}
        </p>
      )}
    </div>
  );
}